export function loadEvents() {
  try {
    let events = JSON.parse(window.localStorage.getItem("grp-events"));
    //console.debug("Loaded from storage:", events);
    return events ? events : [];
  } catch (err) {
    return [];
  }
}

export function saveEvents(events) {
  window.localStorage.setItem("grp-events", JSON.stringify(events));
}
